module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/bca-logo-d3aabd98e59cb6221a47b53cb146c9c1.png";